<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
    :style="height"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <div class="alert alert-danger mb-0" role="alert" v-show="error">
      <div class="container" v-html="error" id="editErrorMessage">
        <!-- {{ error }} -->
      </div>
    </div>

    <main id="main-container">
      <form>
        <div class="content">
          <div class="row bg-light">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="form-group">
                <label class="col-form-label">
                  User Name
                  <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  id="userName"
                  placeholder="User Name"
                  :value="$route.params.id !== '0' ? user.data.name : ''"
                  required
                  @change="handleNameForUpdate"
                />
              </div>
            </div>
          </div>
          <div class="row bg-light">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="form-group">
                <label class="col-form-label">
                  Email
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  :value="$route.params.id !== '0' ? user.data.email : ''"
                  required
                  @change="handleEmailForUpdate"
                />
              </div>
            </div>
          </div>
          <div class="row bg-light">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="form-group">
                <label class="col-form-label">
                  Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="password"
                  class="form-control"
                  type="password"
                  placeholder="Password"
                  @change="handlePasswordForUpdate"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row bg-light mb-6">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="form-group">
                <label class="col-form-label">
                  Confirm Password
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="password2"
                  class="form-control"
                  type="password"
                  placeholder="Confirm Password"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-2"></div>
            <div class="col-4">
              <button
                type="submit"
                class="btn btn-outline-success btn-lg btn-block"
                @click="saveUser"
              >
                Save
              </button>
            </div>
            <div class="col-4">
              <button
                class="btn btn-outline-info btn-lg btn-block"
                @click="$router.push('/account')"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
      <footer
        class="navbar navbar-light p-4 mt-4 w-100"
        style=" background-color: #ffa400 !important;font-size:16px; bottom:0px; position:absolute;"
      >
        <div class="container">
          <a href="/" class="navbar-brand text-dual"
            ><span class="font-w300 text-white">Copyright© 2020</span>
            <span class="font-w300 text-white">ARX</span></a
          >
        </div>
      </footer>
    </main>
  </div>
</template>

<script>
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import { mapActions, mapState } from "vuex";

export default {
  name: "UsersEdit",

  components: {
    SidebarComponent,
    HeaderComponent
  },
  data: () => {
    return {
      userForUpdate: {
        id: null,
        name: "",
        email: "",
        password: ""
      },
      height: "height:" + window.innerHeight + "px"
    };
  },
  created() {
    this.getUserById(this.$route.params.id).then(res => {
      this.userForUpdate.id = res.data.data.id;
      this.userForUpdate.name = res.data.data.name;
      this.userForUpdate.email = res.data.data.email;
    });
  },
  methods: {
    ...mapActions({
      getUserById: "users/getUserById",
      updateUserById: "users/updateUserById",
      registerUser: "users/registerUser"
    }),
    handleNameForUpdate(e) {
      this.userForUpdate.name = e.target.value;
    },
    handleEmailForUpdate(e) {
      this.userForUpdate.email = e.target.value;
    },
    handlePasswordForUpdate(e) {
      this.userForUpdate.password = e.target.value;
    },
    saveUser(e) {
      e.preventDefault();
      if (
        document.getElementById("password2").value ===
        document.getElementById("password").value
      ) {
        if (
          this.userForUpdate.name !== "" &&
          this.userForUpdate.email !== "" &&
          this.userForUpdate.password !== ""
        ) {
          if (this.$route.params.id !== "0") {
            this.updateUserById(this.userForUpdate).then(() => {
              this.$swal.fire("User Updated").then(() => {
                this.$router.push("/");
              });
            });
          } else {
            this.registerUser(this.userForUpdate).then(() => {
              this.$swal.fire("User Added Succesfully").then(() => {
                this.$router.push("/");
              });
            });
          }
        } else {
          this.$swal.fire("Please provide all areas!!!");
        }
      } else {
        this.$swal.fire("Passwords doesnt match!!!");
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.User,
      newUser: state => state.users.NewUser
    })
  }
};
</script>
